module.exports = __webpack_public_path__ + "media/images/desktop/app-download-banner-screen-0c8bce3752fd2f919d73b18a8039ba41.png";